<template>
  <div @mouseenter="enter()" @mouseleave="exit()" :class="{ editable: isEditable, line: true }">
    <div class="inside" :style="{ display: isVisible(true) }">
      <Pip :color="fore" />
    </div>
    <div class="inside" :style="{ display: isVisible(false) }">
      <Pip :color="fore" />
      <div class="spacer" />
      <Pip :color="fore" />
    </div>
  </div>
</template>

<script>
import Pip from "./Pip";

export default {
  name: "NovenaryFigureLine",
  data() {
    return {
      hover: false
    };
  },
  props: {
    isActive: Boolean,
    isEditable: Boolean,
    figureId: Number
  },
  components: {
    Pip
  },
  computed: {
    fore() {
      if (this.isEditable && this.hover) {
        return this.$store.getters.getTheme.highlight;
      }

      if (this.figureId === 7) {
        return this.$store.getters.getTheme.lowlight;
      }

      return this.$store.getters.getTheme.fore;
    }
  },
  methods: {
    enter() {
      this.hover = true;
    },
    exit() {
      this.hover = false;
    },
    isVisible(single) {
      if (this.isActive && single) {
        return "";
      }
      if (!this.isActive && !single) {
        return "";
      }
      return "none";
    }
  }
};
</script>

<style lang="scss" scoped>
.editable {
  cursor: pointer;
}

.line {
  height: 0.94rem;
  display: flex;
  align-items: center;
  justify-content: center;

  .inside {
    width: 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;

    .spacer {
      width: 0.35rem;
    }
  }
}
</style>
